/**
 * @return {Object} // theInitialTheme contains all theme options. Just copy/paste from the cashiers initial theme object.
 */
export const theInitialTheme = () => ({
  input: {
    color: '#5b5b5b',
    fontSize: '14px',
    fontFeatureSettings: 'normal',
    fontVariantNumeric: 'normal',
    fontWeight: 'normal',
    lineHeight: 'normal',
    height: '52px',
    borderRadius: '2px'
  },
  inputbackground: {
    color: '#ffffff'
  },
  labels: {
    color: '#5b5b5b',
    fontSize: '12px',
    fontFeatureSettings: 'normal',
    fontVariantNumeric: 'normal',
    fontWeight: 'normal',
    lineHeight: 'normal'
  },
  headings: {
    color: '#000000',
    fontSize: '14px',
    fontFeatureSettings: 'normal',
    fontVariantNumeric: 'normal',
    fontWeight: 'bold',
    lineHeight: 'normal'
  },
  loader: {
    color: '#46beab'
  },
  error: {
    color: '#ff2e56'
  },
  success: {
    color: '#4BB543'
  },
  buttons: {
    color: '#46beab'
  },
  headerbackground: {
    color: '#ffffff'
  },
  background: {
    color: '#ffffff'
  },
  cashierbackground: {
    color: '#ffffff'
  },
  cardbackground: {
    color: 'transparent'
  },
  border: {
    radius: '3px'
  },
  margin: {
    size: '14px'
  },
  providerlogos: {
    list: '40px',
    dropdown: '26px'
  },
  creditcardicons: {
    creditcardUrl: 'default',
    cvvUrl: 'default',
    expirydateUrl: 'default'
  }
})
